class BundleUpgrade {
  constructor() {
    console.log('🔧 BundleUpgrade: Constructor called');
    this.modal = null;
    this.currentItem = null;
    this.bundleData = null;
    this.selectedVariants = {};
    this.isAddingButtons = false;
    this.init();
  }

  init() {
    console.log('🔧 BundleUpgrade: Initializing...');
    this.createModal();
    
    // Dawn theme uses custom events - listen for these
    this.setupEventListeners();
    
    // Also use MutationObserver as backup
    this.observeCartDrawer();
    
    // Try immediately and with delays
    this.waitForCartAndAddButtons();
  }

  setupEventListeners() {
    console.log('🔧 BundleUpgrade: Setting up event listeners');

    // Listen for Dawn's cart drawer render complete
    document.addEventListener('cart-drawer:rendered', () => {
      console.log('🔧 BundleUpgrade: cart-drawer:rendered event');
      setTimeout(() => this.addUpgradeButtons(), 100);
    });

    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      console.log('🔧 BundleUpgrade: cart:updated event');
      setTimeout(() => this.addUpgradeButtons(), 200);
    });

    // Listen for specific Dawn cart-drawer element events
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (cartDrawerElement) {
      console.log('🔧 BundleUpgrade: Found cart-drawer element, adding listeners');
      
      // When cart drawer opens
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const classList = mutation.target.classList;
            if (classList.contains('active') || !classList.contains('is-empty')) {
              console.log('🔧 BundleUpgrade: Cart drawer opened/changed');
              setTimeout(() => this.addUpgradeButtons(), 300);
            }
          }
        });
      });

      observer.observe(cartDrawerElement, { 
        attributes: true,
        attributeFilter: ['class']
      });
    }

    // Also watch for when drawer inner becomes visible
    setTimeout(() => {
      const drawerInner = document.querySelector('.drawer__inner');
      if (drawerInner) {
        console.log('🔧 BundleUpgrade: Found drawer__inner, adding observer');
        const observer = new MutationObserver(() => {
          console.log('🔧 BundleUpgrade: drawer__inner changed');
          setTimeout(() => this.addUpgradeButtons(), 200);
        });

        observer.observe(drawerInner, {
          childList: true,
          subtree: true,
          attributes: false
        });
      }
    }, 1000);
  }

  waitForCartAndAddButtons() {
    console.log('🔧 BundleUpgrade: Starting timed checks');
    // Try at different intervals
    const intervals = [500, 1000, 2000, 3000, 5000];
    
    intervals.forEach(delay => {
      setTimeout(() => {
        console.log(`🔧 BundleUpgrade: Timed check at ${delay}ms`);
        this.addUpgradeButtons();
      }, delay);
    });
  }

  observeCartDrawer() {
    console.log('🔧 BundleUpgrade: Setting up cart drawer observer');
    
    // Watch for cart items container
    const checkForCartItems = setInterval(() => {
      const cartItemsContainer = document.querySelector('#CartDrawer-CartItems, .drawer__contents, cart-drawer-items');
      
      if (cartItemsContainer) {
        console.log('🔧 BundleUpgrade: Cart items container found');
        clearInterval(checkForCartItems);
        
        const observer = new MutationObserver((mutations) => {
          const hasNewItems = mutations.some(mutation => 
            Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && (
                node.classList?.contains('cart-item') ||
                node.querySelector?.('.cart-item') ||
                node.tagName === 'TR'
              )
            )
          );

          if (hasNewItems) {
            console.log('🔧 BundleUpgrade: New cart items detected via observer');
            setTimeout(() => this.addUpgradeButtons(), 150);
          }
        });

        observer.observe(cartItemsContainer, {
          childList: true,
          subtree: true
        });
      }
    }, 100);

    setTimeout(() => clearInterval(checkForCartItems), 10000);
  }

  createModal() {
    console.log('🔧 BundleUpgrade: Creating modal...');
    
    const modalHTML = `
      <div class="bundle-upgrade-modal" id="bundleUpgradeModal">
        <div class="bundle-upgrade-modal__overlay"></div>
        <div class="bundle-upgrade-modal__content">
          <div class="bundle-upgrade-modal__header">
            <h2 class="bundle-upgrade-modal__title">
              UPGRADE TO BUNDLE 
              <span class="bundle-upgrade-badge">SAVE 25%</span>
            </h2>
            <button class="bundle-upgrade-modal__close" aria-label="Close modal">
              ×
            </button>
          </div>
          <div class="bundle-upgrade-modal__body">
            <div class="bundle-info">
              <img class="bundle-info__image" src="" alt="">
              <div class="bundle-info__details">
                <h3 class="bundle-info__title"></h3>
                <div class="bundle-info__benefits">
                  <div class="bundle-info__benefit">
                    <svg viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                    </svg>
                    Bundle and save!
                  </div>
                  <div class="bundle-info__benefit">
                    <svg viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                    </svg>
                    Free shipping
                  </div>
                </div>
                <div class="bundle-info__price">
                  <span class="bundle-info__price-current"></span>
                  <span class="bundle-info__price-original"></span>
                </div>
              </div>
            </div>
            <div class="bundle-items">
              <div class="bundle-items__label">SIZE:</div>
              <div class="bundle-items__list"></div>
            </div>
          </div>
          <div class="bundle-upgrade-modal__footer">
            <button class="bundle-upgrade-modal__cta">
              <span class="bundle-upgrade-modal__cta-loader"></span>
              <span class="bundle-upgrade-modal__cta-text">UPGRADE TO BUNDLE - £0.00</span>
            </button>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('bundleUpgradeModal');
    console.log('✅ BundleUpgrade: Modal created in body');

    // Close modal events
    this.modal.querySelector('.bundle-upgrade-modal__close').addEventListener('click', () => {
      this.closeModal();
    });

    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    this.modal.querySelector('.bundle-upgrade-modal__cta').addEventListener('click', () => {
      this.upgradeToBundle();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });
  }

  async addUpgradeButtons() {
    console.log('🔧 BundleUpgrade: === addUpgradeButtons START ===');
    
    // Prevent multiple simultaneous executions
    if (this.isAddingButtons) {
      console.log('⚠️ Already adding buttons, skipping...');
      return;
    }
    this.isAddingButtons = true;
    
    try {
      // Try ALL possible selectors for cart items
      const selectors = [
        '.cart-item',
        '[id^="CartDrawer-Item-"]',
        'tr[id^="CartDrawer-Item-"]',
        '.cart__items .cart-item',
        'cart-drawer-items .cart-item',
        '.drawer__contents .cart-item',
        'tbody[role="rowgroup"] tr'
      ];

      let cartItems = [];
      
      for (const selector of selectors) {
        const items = document.querySelectorAll(selector);
        if (items.length > 0) {
          console.log(`✅ Found ${items.length} items with selector: ${selector}`);
          cartItems = items;
          break;
        } else {
          console.log(`❌ No items with selector: ${selector}`);
        }
      }
      
      if (cartItems.length === 0) {
        console.log('⚠️ BundleUpgrade: No cart items found with any selector');
        console.log('🔍 Full cart drawer HTML:', document.querySelector('cart-drawer')?.innerHTML.substring(0, 500));
        return;
      }

      console.log(`✅ Processing ${cartItems.length} cart items`);

      for (let i = 0; i < cartItems.length; i++) {
        const item = cartItems[i];
        console.log(`\n🔧 Processing item ${i + 1}/${cartItems.length}`);
        
        // Check if button already exists - check multiple times to be sure
        const existingButtons = item.querySelectorAll('.bundle-upgrade-button');
        if (existingButtons.length > 0) {
          console.log(`  ⏭️ ${existingButtons.length} button(s) already exist, skipping`);
          continue;
        }
        
        // Also mark this item as processed
        if (item.dataset.bundleChecked) {
          console.log('  ⏭️ Item already checked, skipping');
          continue;
        }
        item.dataset.bundleChecked = 'true';

      // Try ALL possible selectors for variant ID
      const variantSelectors = [
        '[data-quantity-variant-id]',
        'input[name="updates[]"]',
        '[data-variant-id]',
        '[data-index]',
        '.quantity__input'
      ];

      let variantIdElement = null;
      let variantId = null;

      for (const selector of variantSelectors) {
        variantIdElement = item.querySelector(selector);
        if (variantIdElement) {
          variantId = variantIdElement.dataset.quantityVariantId || 
                     variantIdElement.dataset.variantId ||
                     variantIdElement.value ||
                     variantIdElement.id?.match(/\d+/)?.[0];
          
          if (variantId) {
            console.log(`  ✅ Found variant ID: ${variantId} (using ${selector})`);
            break;
          }
        }
      }
      
      if (!variantId) {
        console.log('  ❌ No variant ID found');
        console.log('  Item HTML preview:', item.innerHTML.substring(0, 200));
        continue;
      }

      // Check for bundle
      console.log(`  🔍 Checking for bundle...`);
      const bundleInfo = await this.findBundleForProduct(variantId, item);
      
      if (bundleInfo) {
        console.log(`  ✅ Bundle found: ${bundleInfo.handle}`);
        
        // Check if bundle has any available variants
        if (bundleInfo.product && bundleInfo.product.variants) {
          const hasAvailableVariants = bundleInfo.product.variants.some(v => v.available);
          
          if (!hasAvailableVariants) {
            console.log(`  ⚠️ Bundle is out of stock, skipping button`);
            continue;
          }
          
          console.log(`  ✅ Bundle has available variants`);
        }
        
        this.addUpgradeButton(item, variantId, bundleInfo);
      } else {
        console.log(`  ℹ️ No bundle available for this product`);
      }
    }
    
    console.log('🔧 BundleUpgrade: === addUpgradeButtons END ===\n');
    } finally {
      this.isAddingButtons = false;
    }
  }

  async findBundleForProduct(variantId, cartItemElement) {
    try {
      console.log(`  🔍 Finding product handle from cart item...`);
      
      // Get product handle directly from cart item's product link
      let productHandle = null;
      
      // Try to find product link in cart item
      const productLinks = cartItemElement.querySelectorAll('a[href*="/products/"]');
      console.log(`  Found ${productLinks.length} product links in cart item`);
      
      for (const link of productLinks) {
        const href = link.getAttribute('href');
        console.log(`  Checking link: ${href}`);
        
        if (href && href.includes('/products/')) {
          // Extract handle from URL
          const match = href.match(/\/products\/([^?#/]+)/);
          if (match && match[1]) {
            productHandle = match[1];
            console.log(`  ✅ Product handle found: ${productHandle}`);
            break;
          }
        }
      }
      
      if (!productHandle) {
        console.log(`  ❌ Could not find product handle from cart item links`);
        console.log(`  Cart item HTML:`, cartItemElement.innerHTML.substring(0, 500));
        return null;
      }

      // First check if THIS product is a bundle
      console.log(`  📡 Checking if this product is a bundle...`);
      const productDataResponse = await fetch(`/products/${productHandle}.js`);
      
      if (productDataResponse.ok) {
        const productData = await productDataResponse.json();
        console.log(`  ✅ Product type: ${productData.type}`);
        console.log(`  ✅ Product tags: ${productData.tags}`);
        
        // Check if THIS product is a bundle by type or tag
        const isBundleByType = productData.type && productData.type.toLowerCase().includes('bundle');
        const isBundleByTag = productData.tags && productData.tags.includes('harness-bundle');
        
        if (isBundleByType || isBundleByTag) {
          console.log(`  ✅ This item IS a bundle! (type: ${isBundleByType}, tag: ${isBundleByTag})`);
          return {
            handle: productHandle,
            product: productData,
            isCurrentBundle: true
          };
        }
      }

      // Otherwise, fetch bundle metafield data
      console.log(`  📡 Fetching bundle link for ${productHandle}...`);
      const productResponse = await fetch(`/products/${productHandle}?view=bundle-link`);
      
      if (!productResponse.ok) {
        console.log(`  ℹ️ No bundle-link view (status: ${productResponse.status})`);
        return null;
      }

      const productData = await productResponse.json();
      console.log(`  ✅ Product data:`, productData);
      
      if (productData.bundle_handle) {
        console.log(`  ✅ Bundle handle found: ${productData.bundle_handle}`);
        
        // Fetch the bundle product
        console.log(`  📡 Fetching bundle product...`);
        const bundleResponse = await fetch(`/products/${productData.bundle_handle}.js`);
        
        if (bundleResponse.ok) {
          const bundleProduct = await bundleResponse.json();
          console.log(`  ✅ Bundle product loaded: ${bundleProduct.title}`);
          return {
            handle: productData.bundle_handle,
            product: bundleProduct,
            isCurrentBundle: false
          };
        } else {
          console.log(`  ❌ Bundle product not found`);
        }
      } else {
        console.log(`  ℹ️ No bundle_handle in product data`);
      }

      return null;
    } catch (error) {
      console.error('  ❌ Error finding bundle:', error);
      return null;
    }
  }

  addUpgradeButton(itemElement, variantId, bundleInfo) {
    console.log('  🔧 Adding button to item...');
    
    // Check if this is the bundle itself
    const isBundle = bundleInfo.isCurrentBundle || false;
    
    // Try to find where to insert the button
    const insertLocations = [
      '.cart-item__quantity-wrapper',
      '.cart-item__quantity',
      'quantity-input',
      '.quantity',
      'cart-remove-button',
      '.cart-remove-button'
    ];

    let insertTarget = null;

    for (const selector of insertLocations) {
      insertTarget = itemElement.querySelector(selector);
      if (insertTarget) {
        console.log(`  ✅ Found insert location: ${selector}`);
        break;
      }
    }
    
    if (!insertTarget) {
      console.error('  ❌ Could not find where to insert button');
      console.log('  Item HTML:', itemElement.innerHTML.substring(0, 300));
      return;
    }
    
    const button = document.createElement('button');
    button.className = 'bundle-upgrade-button';
    button.type = 'button';
    
    if (isBundle) {
      // This IS a bundle - show "Edit Size Selections"
      button.innerHTML = `Edit Size Selections`;
      button.classList.add('bundle-upgrade-button--edit');
    } else {
      // This is a single product - show "Upgrade To Bundle"
      button.innerHTML = `Upgrade To Bundle <span class="bundle-upgrade-badge">SAVE 25%</span>`;
    }
    
    button.dataset.variantId = variantId;
    button.dataset.bundleHandle = bundleInfo.handle;
    button.dataset.isBundle = isBundle;

    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log(isBundle ? '🎉 Edit button clicked!' : '🎉 Upgrade button clicked!');
      await this.openModal(variantId, bundleInfo);
    });

    insertTarget.insertAdjacentElement('afterend', button);
    console.log('  ✅ Button added successfully!');
  }

  async openModal(variantId, bundleInfo) {
    console.log('Opening modal...');
    this.currentItem = { variantId, bundleInfo };
    this.selectedVariants = {};

    const response = await fetch(`/products/${bundleInfo.handle}.js`);
    this.bundleData = await response.json();

    await this.populateModal();

    this.modal.classList.add('active');
  }

  async populateModal() {
    const modal = this.modal;
    const bundle = this.bundleData;

    modal.querySelector('.bundle-info__image').src = bundle.featured_image;
    modal.querySelector('.bundle-info__image').alt = bundle.title;
    modal.querySelector('.bundle-info__title').textContent = bundle.title;

    // Original price is the bundle's actual price (before automatic discount)
    const originalPrice = this.formatMoney(bundle.price);
    // Discounted price is 25% off the original
    const discountedPrice = this.formatMoney(Math.round(bundle.price * 0.75));

    modal.querySelector('.bundle-info__price-current').textContent = discountedPrice;
    modal.querySelector('.bundle-info__price-original').textContent = originalPrice;

    const bundleItems = await this.getBundleItems();

    const itemsList = modal.querySelector('.bundle-items__list');
    itemsList.innerHTML = '';

    bundleItems.forEach((item, index) => {
      const itemHTML = this.createBundleItemHTML(item, index);
      itemsList.insertAdjacentHTML('beforeend', itemHTML);
    });

    modal.querySelectorAll('.bundle-item__variant-select').forEach(select => {
      select.addEventListener('change', (e) => {
        const itemId = e.target.dataset.itemId;
        const selectedValue = e.target.value;
        console.log(`🔄 Variant changed for item ${itemId}: ${selectedValue}`);
        this.selectedVariants[itemId] = selectedValue;
        console.log('📋 Current selected variants:', this.selectedVariants);
        
        // Check if selection is valid (all in stock)
        this.checkSelectionAvailability();
      });
    });

    bundleItems.forEach(item => {
      if (item.variants && item.variants.length > 0) {
        this.selectedVariants[item.id] = item.selectedVariant || item.variants[0].id;
      }
    });
    
    console.log('📋 Initial selected variants:', this.selectedVariants);

    // Update button text based on whether this is an edit or upgrade
    const isEdit = this.currentItem.bundleInfo.isCurrentBundle;
    const buttonText = isEdit ? `CONFIRM CHANGES - ${discountedPrice}` : `UPGRADE TO BUNDLE - ${discountedPrice}`;
    modal.querySelector('.bundle-upgrade-modal__cta-text').textContent = buttonText;
    
    // Check initial availability
    this.checkSelectionAvailability();
  }

  checkSelectionAvailability() {
    const modal = this.modal;
    const ctaButton = modal.querySelector('.bundle-upgrade-modal__cta');
    const ctaText = modal.querySelector('.bundle-upgrade-modal__cta-text');
    
    // Check if any selected variant is out of stock
    let hasOutOfStock = false;
    
    modal.querySelectorAll('.bundle-item__variant-select').forEach(select => {
      const selectedOption = select.options[select.selectedIndex];
      const isAvailable = selectedOption.dataset.available === 'true';
      
      if (!isAvailable) {
        hasOutOfStock = true;
      }
    });
    
    if (hasOutOfStock) {
      // Disable button and show out of stock message
      ctaButton.disabled = true;
      ctaButton.classList.add('disabled');
      ctaText.textContent = 'Your Selection Is Out Of Stock';
    } else {
      // Enable button and restore original text
      ctaButton.disabled = false;
      ctaButton.classList.remove('disabled');
      
      const isEdit = this.currentItem.bundleInfo.isCurrentBundle;
      const discountedPrice = modal.querySelector('.bundle-info__price-current').textContent;
      const buttonText = isEdit ? `CONFIRM CHANGES - ${discountedPrice}` : `UPGRADE TO BUNDLE - ${discountedPrice}`;
      ctaText.textContent = buttonText;
    }
  }

  async getBundleItems() {
    console.log('📦 Fetching bundle items...');
    try {
      const url = `/products/${this.bundleData.handle}?view=bundle-data`;
      console.log(`📡 Fetching: ${url}`);
      const response = await fetch(url);
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Bundle data received:', data);
        
        if (data.bundle_items && data.bundle_items.length > 0) {
          console.log(`✅ Found ${data.bundle_items.length} items in bundle:`);
          data.bundle_items.forEach((item, i) => {
            console.log(`  ${i + 1}. ${item.title} - ${item.variants.length} variant(s)`);
          });
          
          return data.bundle_items.map(item => ({
            id: item.id,
            title: item.title,
            image: item.featured_image,
            hasVariants: item.has_variants,
            variants: item.variants,
            selectedVariant: item.variants[0]?.id
          }));
        } else {
          console.log('⚠️ No bundle_items in response or empty array');
        }
      } else {
        console.log(`⚠️ Bundle data view returned status: ${response.status}`);
      }
    } catch (error) {
      console.log('❌ Error fetching bundle data:', error);
    }

    console.log('⚠️ Using fallback: showing bundle product as single item');
    return [{
      id: this.bundleData.id,
      title: this.bundleData.title,
      image: this.bundleData.featured_image,
      hasVariants: this.bundleData.variants.length > 1,
      variants: this.bundleData.variants.map(v => ({
        id: v.id,
        title: v.title,
        option1: v.option1,
        available: v.available
      })),
      selectedVariant: this.bundleData.variants[0].id
    }];
  }

  createBundleItemHTML(item, index) {
    // Function to abbreviate size names
    const abbreviateSize = (size) => {
      const sizeMap = {
        'Extra Small': 'XS',
        'Small': 'S',
        'Medium': 'M',
        'Large': 'L',
        'Extra Large': 'XL',
        'XX Large': 'XXL',
        'XXX Large': 'XXXL',
        '5FT (Standard)': '5FT',
        'Default Title': 'One Size'
      };
      return sizeMap[size] || size;
    };
    
    let variantOptions = '';
    
    if (item.hasVariants && item.variants && item.variants.length > 1) {
      // Multi-variant - show as dropdown with stock status
      variantOptions = `
        <div class="bundle-item__variant-selector">
          <select class="bundle-item__variant-select" data-item-id="${item.id}">
            ${item.variants.map(v => {
              const sizeLabel = v.title || v.option1;
              const abbreviatedSize = abbreviateSize(sizeLabel);
              const outOfStock = !v.available;
              const displayText = outOfStock ? `${abbreviatedSize} (sold out)` : abbreviatedSize;
              const disabled = outOfStock ? 'disabled' : '';
              const selected = v.id === item.selectedVariant ? 'selected' : '';
              const className = outOfStock ? 'out-of-stock' : '';
              
              return `<option value="${v.id}" ${selected} ${disabled} class="${className}" data-available="${v.available}">${displayText}</option>`;
            }).join('')}
          </select>
        </div>
      `;
    } else if (item.variants && item.variants.length > 0) {
      // Single variant - show "One Size"
      variantOptions = `
        <div class="bundle-item__variant-selector bundle-item__variant-selector--single">
          <span class="bundle-item__one-size">One Size</span>
        </div>
      `;
    }

    return `
      <div class="bundle-item">
        <img class="bundle-item__image" src="${item.image}" alt="${item.title}" loading="lazy">
        <div class="bundle-item__details">
          <h4 class="bundle-item__title">${item.title}</h4>
        </div>
        ${variantOptions}
      </div>
    `;
  }

  async upgradeToBundle() {
    const ctaButton = this.modal.querySelector('.bundle-upgrade-modal__cta');
    ctaButton.classList.add('loading');
    ctaButton.disabled = true;

    try {
      console.log('🔍 Selected variants:', this.selectedVariants);
      
      // Get the selected size options from each item
const bundleItems = await this.getBundleItems();

// Create a map of product title to selected size
const productSizes = {};

bundleItems.forEach(item => {
  const selectedVariantId = this.selectedVariants[item.id];
  const selectedVariant = item.variants.find(v => v.id == selectedVariantId);
  if (selectedVariant) {
    const optionValue = selectedVariant.option1 || selectedVariant.title;
    if (optionValue !== 'Default Title') {
      productSizes[item.title] = optionValue;
      console.log(`  ${item.title}: ${optionValue}`);
    }
  }
});

// Build selectedOptions array in the correct order: Collar FIRST, then Harness
const selectedOptions = [];

// Add collar size first (check for any product with "Collar" in title)
const collarItem = bundleItems.find(item => item.title.toLowerCase().includes('collar'));
if (collarItem && productSizes[collarItem.title]) {
  selectedOptions.push(productSizes[collarItem.title]);
  console.log(`  Collar (${collarItem.title}): ${productSizes[collarItem.title]}`);
}

// Add harness size second
const harnessItem = bundleItems.find(item => item.title.toLowerCase().includes('harness'));
if (harnessItem && productSizes[harnessItem.title]) {
  selectedOptions.push(productSizes[harnessItem.title]);
  console.log(`  Harness (${harnessItem.title}): ${productSizes[harnessItem.title]}`);
}

console.log('📋 Looking for bundle variant with options:', selectedOptions);
      
      // Try to find a bundle variant that matches the selected options
      let variantToAdd = null;
      
      // For bundles, the variant options represent the sizes of variable components only
      for (const variant of this.bundleData.variants) {
        const variantOptions = [variant.option1, variant.option2, variant.option3].filter(opt => opt && opt !== 'Default Title');
        console.log(`  Checking variant: ${variant.title} - [${variantOptions.join(', ')}]`);
        
        // Check if all selected options match this variant
        const matches = selectedOptions.length === variantOptions.length && 
                       selectedOptions.every((selectedOpt, index) => {
                         return variantOptions[index] === selectedOpt;
                       });
        
        if (matches && variant.available) {
          variantToAdd = variant;
          console.log(`  ✅ Found matching variant: ${variant.title}`);
          break;
        }
      }
      
      // If no exact match found, try to find any available variant
      if (!variantToAdd) {
        console.log('  ⚠️ No exact match found, using first available variant');
        variantToAdd = this.bundleData.variants.find(v => v.available);
      }
      
      // Last resort: use first variant even if not available
      if (!variantToAdd) {
        console.log('  ⚠️ No available variants, using first variant');
        variantToAdd = this.bundleData.variants[0];
      }
      
      console.log(`✅ Will add bundle variant: ${variantToAdd.title} (ID: ${variantToAdd.id})`);

      const itemToRemove = this.currentItem.variantId;
      const isEdit = this.currentItem.bundleInfo.isCurrentBundle;

      if (isEdit) {
        // This is an edit - just update the existing bundle to the new variant
        console.log('🔄 Updating existing bundle variant...');
        
        // Remove old variant
        await this.updateCart(itemToRemove, 0);
        
        // Add new variant
        await this.addToCart(variantToAdd.id, 1);
        
        console.log('✅ Bundle updated successfully');
      } else {
        // This is an upgrade - remove single item and add bundle
        console.log('🔄 Adding bundle to cart...');
        await this.addToCart(variantToAdd.id, 1);

        console.log('🔄 Removing single item from cart...');
        await this.updateCart(itemToRemove, 0);

        console.log('✅ Cart updated successfully');
      }
      
      // Close modal
      this.closeModal();
      
      // Refresh cart drawer using Dawn's method
      console.log('🔄 Refreshing cart drawer...');
      
      try {
        // Fetch updated cart drawer section
        const response = await fetch(`${window.location.origin}/?sections=cart-drawer,cart-icon-bubble`);
        const sections = await response.json();
        
        console.log('✅ Sections fetched:', Object.keys(sections));
        
        // Update cart drawer
        if (sections['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          
          // Find and update the cart items container
          const newCartItems = doc.querySelector('#CartDrawer-CartItems');
          const currentCartItems = document.querySelector('#CartDrawer-CartItems');
          
          if (newCartItems && currentCartItems) {
            currentCartItems.innerHTML = newCartItems.innerHTML;
            console.log('✅ Cart items updated');
          }
          
          // Update subtotal
          const newSubtotal = doc.querySelector('.totals__subtotal-value');
          const currentSubtotal = document.querySelector('.totals__subtotal-value');
          
          if (newSubtotal && currentSubtotal) {
            currentSubtotal.textContent = newSubtotal.textContent;
            console.log('✅ Subtotal updated');
          }
        }
        
        // Update cart icon bubble
        if (sections['cart-icon-bubble']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          
          const newBubble = doc.querySelector('.cart-count-bubble');
          const currentBubble = document.querySelector('.cart-count-bubble');
          
          if (newBubble && currentBubble) {
            currentBubble.textContent = newBubble.textContent;
            console.log('✅ Cart bubble updated');
          }
        }
        
        // Dispatch event for other scripts
        document.dispatchEvent(new CustomEvent('cart:updated'));

        // Update free shipping progress bar
try {
  const progressWrapper = document.getElementById('cart-progress-wrapper');
  if (progressWrapper && window.updateCartProgress) {
    console.log('🔄 Updating free shipping progress bar...');
    window.updateCartProgress();
  } else if (progressWrapper) {
    console.log('🔄 Triggering cart progress update via fetch...');
    // If no global function, fetch current cart total and trigger update manually
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const threshold = parseFloat(progressWrapper.dataset.threshold);
        const currentTotal = cart.total_price;
        const progressBar = document.getElementById('cart-progress-bar');
        const goalMessage = progressWrapper.querySelector('.goal-message');
        
        if (currentTotal >= threshold) {
          // Goal reached
          progressBar.style.width = '100%';
          progressBar.style.display = 'block';
          goalMessage.innerHTML = progressWrapper.dataset.postGoalMessage;
          goalMessage.style.display = 'block';
          progressWrapper.classList.add('full');
        } else {
          // Calculate progress
          const percentage = (currentTotal / threshold) * 100;
          const remaining = threshold - currentTotal;
          const remainingFormatted = progressWrapper.dataset.moneyFormat.replace('{{amount}}', (remaining / 100).toFixed(2));
          
          progressBar.style.width = percentage + '%';
          progressBar.style.display = 'block';
          
          const preGoalMessage = progressWrapper.dataset.preGoalMessageTemplate
            .replace('[remainingForGoalFormatted]', remainingFormatted);
          goalMessage.innerHTML = preGoalMessage;
          goalMessage.style.display = 'block';
          progressWrapper.classList.remove('full');
        }
        
        console.log('✅ Free shipping progress updated');
      })
      .catch(err => console.error('❌ Error updating progress bar:', err));
  }
} catch (error) {
  console.error('❌ Error with free shipping bar:', error);
}
        
        // Re-add upgrade buttons to new cart items
        setTimeout(() => {
          console.log('🔄 Re-adding upgrade buttons...');
          this.addUpgradeButtons();
        }, 300);
        
      } catch (refreshError) {
        console.error('❌ Error refreshing cart sections:', refreshError);
        console.log('⚠️ Falling back to page reload');
        window.location.reload();
      }

    } catch (error) {
      console.error('❌ Error upgrading:', error);
      alert('Sorry, there was an error. Please try again.');
      
      ctaButton.classList.remove('loading');
      ctaButton.disabled = false;
    }
  }

  async updateCart(variantId, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });
    if (!response.ok) throw new Error('Failed to update cart');
    return response.json();
  }

  async addToCart(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    });
    if (!response.ok) throw new Error('Failed to add to cart');
    return response.json();
  }

  closeModal() {
    this.modal.classList.remove('active');
    this.currentItem = null;
    this.bundleData = null;
    this.selectedVariants = {};
    
    // Reset button loading state
    const ctaButton = this.modal.querySelector('.bundle-upgrade-modal__cta');
    if (ctaButton) {
      ctaButton.classList.remove('loading');
      ctaButton.disabled = false;
    }
  }

  formatMoney(cents) {
    return `£${(cents / 100).toFixed(2)}`;
  }
}

// Initialize
console.log('🚀 BundleUpgrade: Script loaded');
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('🚀 Creating BundleUpgrade instance');
    new BundleUpgrade();
  });
} else {
  console.log('🚀 Creating BundleUpgrade instance immediately');
  new BundleUpgrade();
}